// Incident fields a user may clear back to null from the incident detail views, via
// the Clear link under the input while editing. A null value in
// UpdateIncidentMutationInput is ignored, so each clear is its own input flag
// (clear_incident_date / clear_incident_time in incidents/mutations.py).
export const CLEARABLE_INCIDENT_FIELDS = {
    incidentDate: { inputFlag: "clearIncidentDate" },
    incidentTime: { inputFlag: "clearIncidentTime" },
}

export const clearFieldInput = (incidentId, fieldName) => ({
    incidentId,
    [CLEARABLE_INCIDENT_FIELDS[fieldName].inputFlag]: true,
})
